<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <el-button type='primary' icon='sys sys-add' class='navbarbtn' v-if='showAddPower'
        @click='showMainTableEditorDialogMD'>
        新 增
      </el-button>

      <el-button type='danger' icon='sys sys-batchdelete' class='navbarbtn' v-if='showBatchDeletePower'
        @click='batchDeleteMainTableEditor'>
        删 除
      </el-button>

      <el-button type='success' icon='sys sys-sql' class='navbarbtn' v-if='showExportMoveSqlPower'
        @click='createMainTableEditorMoveSQL()'>
        导出SQL
      </el-button>

      <!-- <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button> -->

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>
    </div>

    <!-- 行展开收起    :expandRowKeys='mainTable.expandRowKeys' -->
    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='true'
      :showDefaultExpandColumn='true' :showExpandColumn='false'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='编辑' placement='top-start' v-if='showEditPower'>
          <el-button type='primary' circle style='padding: 4px;' @click='showMainTableEditorDialogEditMD(scope)'><i class='sys sys-edit'></i></el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='删除' placement='top-start' v-if='showDeletePower'>
          <el-button type='danger' circle style='padding: 4px;' @click='deleteOneMainTableEditor(scope)'><i class='sys sys-delete'></i></el-button>
        </el-tooltip>
      </template>
    </Table>

    <el-dialog v-dialogDrag :title='mainTableEditor.editFlag ? "变更" + mainTableEditor.tableEditorInfo.TableEditorName : "添加" + mainTableEditor.tableEditorInfo.TableEditorName'
      :visible.sync='showMainTableEditorDialog'
      :width='(mainTableEditor.editFlag ? mainTableEditor.tableEditorInfo.EditWidth + 40 : mainTableEditor.tableEditorInfo.SaveWidth + 40) + "px"'
      top='10px' lock-scroll>
      <TableEditor :tableEditorFieldInfo='mainTableEditor.tableEditorFieldInfo'
        :tableEditorContent='mainTableEditor.tableEditorContent'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :style='{ "margin-top": "-20px", height: (mainTableEditor.editFlag ? mainTableEditor.tableEditorInfo.EditHeight : mainTableEditor.tableEditorInfo.SaveHeight) + "px"}'
        :tableEditorInfo='mainTableEditor.tableEditorEditorInfo' :editFlag='mainTableEditor.editFlag'>
      </TableEditor>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='saveOrEditMainTableEditor()' size='mini'>保存</el-button>
        <el-button @click='mainTableEditorReset()' size='mini'>重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import tableEditor from '@/components/sys/TableEditor'
import TableEditor from '@/components/sys/TableEditor.vue'
import power from '@/components/sys/Power'
import { Loading } from 'element-ui'

export default {
  name: 'ServiceIntervalTime',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    TableEditor: TableEditor
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'SYS_ServiceIntervalTime',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      showMainTableEditorDialog: false,
      mainTableEditor: {
        tableEditorCode: 'SYS_ServiceIntervalTime',
        tableEditorInfo: {},
        tableEditorFieldInfo: [],
        oldTableEditorContent: {},
        tableEditorContent: {},
        editFlag: false
      },

      showAddPower: false,
      showEditPower: false,
      showDeletePower: false,
      showBatchDeletePower: false,
      showExportMoveSqlPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)
    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      return {}
    },

    // 表格编辑器新增弹出框显示方法
    showMainTableEditorDialogMD: async function () {
      const that = this
      that.mainTableEditor.editFlag = false
      await tableEditor.showTableEditor(that, 'mainTableEditor')
      that.showMainTableEditorDialog = true
    },

    // 表格编辑器修改弹出框显示方法
    showMainTableEditorDialogEditMD: async function (scope) {
      const that = this
      that.mainTableEditor.oldTableEditorContent = scope.data.row
      that.mainTableEditor.editFlag = true
      await tableEditor.showTableEditor(that, 'mainTableEditor')
      that.showMainTableEditorDialog = true
    },

    // 表格编辑器新增修改弹出框数据重置方法
    mainTableEditorReset: function () {
      const that = this
      tableEditor.tableEditorReset(that, 'mainTableEditor')
    },

    // 表格编辑器数据新增修改
    saveOrEditMainTableEditor: async function () {
      const that = this
      const rtnObj = await tableEditor.saveOrEditTableEditor(that, 'mainTableEditor')
      if (!rtnObj) return
      if (rtnObj.error === '000000') {
        that.$message.success(that.mainTableEditor.editFlag ? '恭喜你，变更' + that.mainTableEditor.tableEditorInfo.TableEditorName + '成功！' : '恭喜你，新增' + that.mainTableEditor.tableEditorInfo.TableEditorName + '成功！')
        that.refreshMainTableContent()
        that.showMainTableEditorDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
    },

    // 表格编辑器数据批量删除方法
    deleteMainTableEditor: async function (selectedTableEditorContent) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await tableEditor.deleteTableEditor(that, 'mainTableEditor', selectedTableEditorContent)
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('恭喜你，删除' + that.mainTableEditor.tableEditorInfo.TableEditorName + '成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 表格编辑器删除某行数据确认弹出框显示方法
    deleteOneMainTableEditor: async function (scope) {
      const that = this
      await tableEditor.showTableEditor(that, 'mainTableEditor')
      that.$confirm('此操作将永久删除该' + that.mainTableEditor.tableEditorInfo.TableEditorName + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.deleteMainTableEditor([scope.data.row])
      }).catch(() => {
      })
    },

    // 表格编辑器批量删除确认弹出框显示方法
    batchDeleteMainTableEditor: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      await tableEditor.showTableEditor(that, 'mainTableEditor')
      that.$confirm('此操作将永久删除该' + that.mainTableEditor.tableEditorInfo.TableEditorName + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.deleteMainTableEditor(that.mainTable.selections)
      }).catch(() => {
      })
    },

    // 表格编辑器数据快速迁移SQL生成方法
    createMainTableEditorMoveSQL: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      tableEditor.createTableEditorMoveSQL(that, 'mainTableEditor', that.mainTable.selections)
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
